import { render, staticRenderFns } from "./bus_item.vue?vue&type=template&id=d11770c0"
import script from "./bus_item.vue?vue&type=script&lang=js"
export * from "./bus_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports